<template>
  <div
    v-if="events"
    class="calandr_main calandr_main_add_app pop-date flex flex--column only-in-app pop-date-events"
  >
    <div class="glob-date-open bg--white">
      <a
        @click="TOGGLE_CALENDAR_POPUP(false)"
        class="restart-date flex flex--center cursor-p"
      >
        <img src="/assets/img/svg/close-sm-blue.svg" />
      </a>
      <vue-cal
        xsmall
        locale="he"
        :time="false"
        :startWeekOnSunday="true"
        hide-view-selector
        active-view="month"
        :disable-views="['years', 'week', 'day']"
        @cell-focus="onCellClick"
        class="vuecal--green-theme vuecal--rounded-theme mini-month"
        :events="events"
        events-count-on-year-view
        @view-change="changeView"
        :hide-weekdays="[6]"
      >
        <template v-slot:weekday-heading="{ heading }">
          <span v-if="heading.label == 'ראשון'">א׳</span>
          <span v-if="heading.label == 'שני'">ב׳</span>
          <span v-if="heading.label == 'שלישי'">ג׳</span>
          <span v-if="heading.label == 'רביעי'">ד׳</span>
          <span v-if="heading.label == 'חמישי'">ה׳</span>
          <span v-if="heading.label == 'שישי'">ו׳</span>
          <span v-if="heading.label == 'שבת'">ש׳</span>
        </template>
        <template v-slot:events-count="{ events }">
          <span> {{ countDot(events) }} </span>
        </template>
      </vue-cal>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/he.es.js";
import "vue-cal/dist/vuecal.css";
import Error from "@/components/Popups/Error";
import {
  buildAppointmentEvent,
  buildBlockEvent,
  filterEventsByPersonalLicense
} from "../../utilities/build-type-event.js";

export default {
  name: "CalendarPopup",
  components: { VueCal },
  data() {
    return {
      events: null,
      currentView: "month"
    };
  },
  computed: {
    ...mapGetters(["activeUser", "activeDoctor", "selectedDateMobiscroll"])
  },
  methods: {
    ...mapMutations(["TOGGLE_CALENDAR_POPUP"]),
    countDot(events) {
      return events ? events.filter(e => e.type === "appointment").length : 0;
    },
    isDateInRange(checkDate = this.selectedDateMobiscroll) {
      if (!this.events) return false;
      const startRangeDate = this.$moment(this.events[0].start);
      const endRangeDate = this.$moment(
        this.events[this.events.length - 1].start
      );
      const checkDateOneMonthBackward = this.$moment(checkDate).subtract(
        1,
        "M"
      );
      const checkDateOneMonthForward = this.$moment(checkDate).add(1, "M");
      return (
        checkDateOneMonthBackward.isSameOrAfter(startRangeDate) &&
        checkDateOneMonthForward.isSameOrBefore(endRangeDate)
      );
    },
    async getEvents(date = this.selectedDateMobiscroll) {
      const inRange = this.isDateInRange(date);
      if (inRange) return;

      // get dates range for api call
      let startDate, endDate;
      if (this.currentView == "year") {
        const momentDate = this.$moment(date);
        startDate = this.$moment([momentDate.year(), 0, 1]).format(
          "YYYY-MM-DD"
        );
        endDate = this.$moment([momentDate.year() + 1, 0, 30]).format(
          "YYYY-MM-DD"
        );
      } else {
        startDate = this.$moment(date)
          .subtract(1, "M")
          .format("YYYY-MM-DD");
        endDate = this.$moment(date)
          .add(3, "M")
          .format("YYYY-MM-DD");
      }
      try {
        const events = await this.$API.getFullCalendarEvents(
          this.activeUser.user_id,
          this.activeDoctor.id,
          "appointment",
          startDate,
          endDate
        );
        if (!events) {
          this.$modal.show(Error);
          return;
        }
        // in shared calendars keep only the events of the connected doctor
        this.events = filterEventsByPersonalLicense(events).map(event => {
          if (event.appointment_id) {
            return buildAppointmentEvent(event, this.$route.name);
          } else {
            return buildBlockEvent(event);
          }
        });
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    changeView(ev) {
      this.currentView = ev.view;
      this.getEvents(ev.startDate);
    },
    onCellClick(ev) {
      this.$emit("change-date", {
        date: ev
      });
      this.TOGGLE_CALENDAR_POPUP(false);
    }
  },
  mounted() {
    const today = this.$moment().format("YYYY-MM-DD");
    this.getEvents(today);
  }
};
</script>
